import { useAuth0 } from "@auth0/auth0-react"
import { useMutation } from "react-query"
import { ProjectsService } from "src/services/projects.service";

export const useDuplicateProject = () => {
    const auth0 = useAuth0();
    return useMutation({
        mutationFn: async (projectId: string) => {
            const project = await ProjectsService.duplicateProject(projectId, auth0);
            return project;
        }
    })
};
